import { Text } from "../../../../packages/ui-kit";
import styles from "./chat-message.module.scss";

type Props = {
  time: string;
};

export const ChatMessageTime = ({ time }: Readonly<Props>) => (
  <Text dataTestId="chat-message-time" className={styles.time} size="small">
    {time}
  </Text>
);
